export class Filter {

    titulo:string;
    tematica:string;
    tipo:string;
    nombre:string;
    sqTematica:string;
    
}
